import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgList = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.709 17.836h8.727M10.709 12h8.727M10.709 6.184h8.727M5.65 18.904a1.085 1.085 0 1 0 0-2.17 1.085 1.085 0 0 0 0 2.17M5.65 13.084a1.085 1.085 0 1 0 0-2.17 1.085 1.085 0 0 0 0 2.17M5.65 7.267a1.085 1.085 0 1 0 0-2.17 1.085 1.085 0 0 0 0 2.17"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
